import { Box, Tooltip, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import CoffeeIcon from "@mui/icons-material/Coffee";
import EditIcon from "@mui/icons-material/Edit";
import AssignedOrdersCell from "./AssignedOrdersCell";

const ActionsCell = ({
  params,
  handleEdit,
  setOpenDeleteUser,
  setOpen,
  setSelectedUser,
  setOpenBreakReport,
  setSelectedUserForBreakReport,
}) => {
  const onEditClick = () => {
    handleEdit(params.row);
    console.log("params check", params)
  };

  const onDeleteClick = () => {
    setSelectedUser(params.row);
    setOpenDeleteUser(true);
  };

  const onClearOrdersClick = () => {
    setSelectedUser(params.row);
    setOpen(true);
  };

  const onBreakReportClick = () => {
    setSelectedUserForBreakReport(params.row);
    setOpenBreakReport(true);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1, // Keep a small gap for a tighter layout
        height: "100%",
        minHeight: "52px",
      }}
    >
      {/* Edit Button - Always visible with icon and text */}

      {params.row.allow_edit === 1 && (
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: "#FAFAFA",
          borderRadius: "6px",
          border: "1px solid #E0E0E0",
          padding: "4px 0",
          gap: 1,
        }}
      >
        <Tooltip title="Edit">
          <Box
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
              padding: "4px 8px",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#F0F0F0",
              },
            }}
            onClick={onEditClick}
          >
            <EditIcon fontSize="small" color="primary" />
            <Typography
              variant="body2"
              sx={{
                ml: 1,
                fontSize: "13px",
                fontWeight: 500,
                color: "#1976D2",
              }}
            >
              Edit
            </Typography>
          </Box>
        </Tooltip>
      </Box>
      )}

      {/* Delete Button - Conditionally visible with icon and text */}
      {params.row.user_deleted_button === 1 && (
        <>
          <Box
            sx={{
              height: "20px",
              width: "1px",
              backgroundColor: "#E0E0E0",
            }}
          />
          <Box
            display="flex"
            alignItems="center"
            sx={{
              backgroundColor: "#FAFAFA",
              borderRadius: "6px",
              border: "1px solid #E0E0E0",
              padding: "4px 8px",
              gap: 1,
            }}
          >
            <Tooltip title="Delete">
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  cursor: "pointer",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "#F0F0F0",
                  },
                }}
                onClick={onDeleteClick}
              >
                <DeleteForeverIcon fontSize="small" color="error" />
                <Typography
                  variant="body2"
                  sx={(theme) => ({
                    ml: 1,
                    fontSize: "13px",
                    fontWeight: 500,
                    color: theme.palette.error.main,
                  })}
                >
                  Delete
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </>
      )}

      {/* Clear Orders Button - Conditionally visible with icon and text */}
      {params.row.clear_order_log_button_enabled === 1 && (
        <>
          <Box
            sx={{
              height: "20px",
              width: "1px",
              backgroundColor: "#E0E0E0",
            }}
          />
          <Box
            display="flex"
            alignItems="center"
            sx={{
              backgroundColor: "#FAFAFA",
              borderRadius: "6px",
              border: "1px solid #E0E0E0",
              padding: "4px 8px",
              gap: 1,
            }}
          >
            <Tooltip title="Clear Orders">
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  cursor: "pointer",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "#F0F0F0",
                  },
                }}
                onClick={onClearOrdersClick}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  onClick={(e) => e.stopPropagation()}
                >
                  <AssignedOrdersCell data={params.row.assigned_orders} />
                </Box>
                <HourglassEmptyIcon
                  fontSize="small"
                  color="warning"
                  sx={{ ml: 1 }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    ml: 1,
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#ff9800",
                  }}
                >
                  {`Clear Order${
                    params.row.assigned_orders.length !== 1 ? "s" : ""
                  }`}
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </>
      )}

      {/* Break Report Button - Conditionally visible with icon and text */}
      {params.row.break_report_button_enabled === 1 && (
        <>
          <Box
            sx={{
              height: "20px",
              width: "1px",
              backgroundColor: "#E0E0E0",
            }}
          />
          <Box
            display="flex"
            alignItems="center"
            sx={{
              backgroundColor: "#FAFAFA",
              borderRadius: "6px",
              border: "1px solid #E0E0E0",
              padding: "4px 8px",
              gap: 1,
            }}
          >
            <Tooltip title="Break Report">
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  cursor: "pointer",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "#F0F0F0",
                  },
                }}
                onClick={onBreakReportClick}
              >
                <CoffeeIcon fontSize="small" color="warning" />
                <Typography
                  variant="body2"
                  sx={{
                    ml: 1,
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#f57c00",
                  }}
                >
                  Break Report
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ActionsCell;
